import React from "react";
import styled from "styled-components";
import AnimateOnScroll from "../AnimateOnScroll";

// Placeholder images - you can replace these with actual event images
import EventImg1 from "../../assets/img/image2-285x406-200x200.png";
import EventImg2 from "../../assets/images/IMG_2836.JPG";
import EventImg3 from "../../assets/images/IMG_2839.JPG";

export default function UpcomingEvents() {
  return (
    <Section id="upcoming-events">
      <div className="container">
        <HeaderRow className="flexSpaceCenter">
          <AnimateOnScroll animation="fadeUp" delay={0} duration={800}>
            <div>
              <Badge className="font13 semiBold">
                <span className="badge-icon">📅</span>
                Our Upcoming Events
              </Badge>
              <h3 className="font40 extraBold">Upcoming Events</h3>
              <p className="font16">View Upcoming PREPA events in various departments across Cameroon. Join us for comprehensive preparation sessions and orientation programs.</p>
              <ViewAllButton className="font15 semiBold">View All</ViewAllButton>
            </div>
          </AnimateOnScroll>
        </HeaderRow>

        <EventsTimeline>
          <AnimateOnScroll animation="slideRight" delay={0} duration={800}>
            <EventCard>
              <EventDate>
                <Day className="afriqBlueBg whiteColor">06</Day>
                <Month className="afriqBlueBg whiteColor">Jun</Month>
              </EventDate>
              <EventImage>
                <img src={EventImg1} alt="Engineering Schools PREPA" />
              </EventImage>
              <EventContent>
                <EventTitle className="font20 extraBold">PREPA into All Engineering Schools in the Country</EventTitle>
                <EventTime className="font14 semiBold">7:00 AM - 5:00 PM</EventTime>
                <EventLocations>
                  <LocationItem>AMACOS COMMERCIAL AVENUE</LocationItem>
                  <LocationItem>VETERINARY JUNCTION</LocationItem>
                  <LocationItem>HOSPITAL ROUNDABOUT</LocationItem>
                  <LocationItem>ABEGE MILE 2</LocationItem>
                  <LocationItem>PRESTIGE MILE 3</LocationItem>
                  <LocationItem>HIPDET MILE 4</LocationItem>
                  <LocationItem>OXFORD BAMBILI</LocationItem>
                  <LocationItem>UPSTATION</LocationItem>
                </EventLocations>
                <EventDescription className="font15">
                  We Shall be Offering Unique Training and Preparation for upcoming Competitive Engineering Exams such as NAHPI, COLTECH, FET, COT AND OTHERS.
                </EventDescription>
                <EventTag className="afriqBlueBg whiteColor">Engineering PREPA</EventTag>
              </EventContent>
            </EventCard>
          </AnimateOnScroll>

          <AnimateOnScroll animation="slideRight" delay={200} duration={800}>
            <EventCard>
              <EventDate>
                <Day className="afriqRedBg whiteColor">6</Day>
                <Month className="afriqRedBg whiteColor">Jun</Month>
              </EventDate>
              <EventImage>
                <img src={EventImg2} alt="Medical Schools PREPA" />
              </EventImage>
              <EventContent>
                <EventTitle className="font20 extraBold">PREPA into Medical Schools</EventTitle>
                <EventTime className="font14 semiBold">7:00 AM - 5:00 PM</EventTime>
                <EventLocations>
                  <LocationItem>AMACOS COMMERCIAL AVENUE</LocationItem>
                  <LocationItem>VETERINARY JUNCTION</LocationItem>
                  <LocationItem>HOSPITAL ROUNDABOUT</LocationItem>
                  <LocationItem>ABEGE MILE 2</LocationItem>
                  <LocationItem>PRESTIGE MILE 3</LocationItem>
                  <LocationItem>HIPDET MILE 4</LocationItem>
                  <LocationItem>OXFORD BAMBILI</LocationItem>
                  <LocationItem>UPSTATION</LocationItem>
                </EventLocations>
                <EventDescription className="font15">
                  We shall be offering Preparatory classes into All Medical schools in the country Such as General Medicine, nursing, laboratory tech, veterinary doctors and all professional medical schools.
                </EventDescription>
                <EventTag className="afriqRedBg whiteColor">Medical PREPA</EventTag>
              </EventContent>
            </EventCard>
          </AnimateOnScroll>

          <AnimateOnScroll animation="slideRight" delay={400} duration={800}>
            <EventCard>
              <EventDate>
                <Day className="afriqYellowBg darkColor">On</Day>
                <Month className="afriqYellowBg darkColor">Going</Month>
              </EventDate>
              <EventImage>
                <img src={EventImg3} alt="University Orientation" />
              </EventImage>
              <EventContent>
                <EventTitle className="font20 extraBold">Basic Orientation for First Year University Students</EventTitle>
                <EventTime className="font14 semiBold">7:00 AM - 5:00 PM</EventTime>
                <EventLocations>
                  <LocationItem>AMACOS COMMERCIAL AVENUE</LocationItem>
                  <LocationItem>VETERINARY JUNCTION</LocationItem>
                  <LocationItem>HOSPITAL ROUNDABOUT</LocationItem>
                  <LocationItem>ABEGE MILE 2</LocationItem>
                  <LocationItem>PRESTIGE MILE 3</LocationItem>
                  <LocationItem>HIPDET MILE 4</LocationItem>
                  <LocationItem>OXFORD BAMBILI</LocationItem>
                  <LocationItem>UPSTATION</LocationItem>
                </EventLocations>
                <EventDescription className="font15">
                  Guidance and counselling concerning for students just entering the university. Comprehensive orientation program to help new students transition smoothly into university life.
                </EventDescription>
                <EventTag className="afriqYellowBg darkColor">Orientation</EventTag>
              </EventContent>
            </EventCard>
          </AnimateOnScroll>
        </EventsTimeline>
      </div>
    </Section>
  );
}

const Section = styled.section`
  padding: 120px 0;
  background: #f8f8ff;
  position: relative;
  
  @media (max-width: 768px) {
    padding: 80px 0;
  }
  
  @media (max-width: 480px) {
    padding: 60px 0;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 20%, rgba(75, 46, 131, 0.03) 0%, transparent 50%),
      radial-gradient(circle at 80% 80%, rgba(75, 46, 131, 0.03) 0%, transparent 50%),
      radial-gradient(circle at 50% 50%, rgba(75, 46, 131, 0.03) 0%, transparent 50%);
    z-index: 1;
  }
`;

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #4b2e83;
  color: white;
  padding: 10px 20px;
  border-radius: 25px;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.8rem;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(75, 46, 131, 0.3);
  }
  
  .badge-icon {
    font-size: 14px;
  }
`;

const ViewAllButton = styled.button`
  background: #f8f8ff;
  border: 2px solid #4b2e83;
  color: #4b2e83;
  padding: 12px 24px;
  border-radius: 25px;
  margin-top: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background: #f0f0f0;
    color: #4b2e83;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(75, 46, 131, 0.3);
  }
`;

const HeaderRow = styled.div`
  margin-bottom: 80px;
  position: relative;
  z-index: 2;
  text-align: center;
  
  h3 {
    margin-bottom: 20px;
    color: #4b2e83;
    font-size: clamp(1.75rem, 4vw, 2.5rem);
    line-height: 1.3;
  }
  
  p {
    color: #000000;
    line-height: 1.7;
    max-width: 700px;
    margin: 0 auto 20px;
    font-size: clamp(0.9rem, 2vw, 1rem);
  }
`;

const EventsTimeline = styled.div`
  position: relative;
  z-index: 2;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
  
  &::before {
    content: '';
    position: absolute;
    left: 50px;
    top: 0;
    bottom: 0;
    width: 4px;
    background: #4b2e83;
    border-radius: 2px;
    z-index: 0;
    
    @media (max-width: 768px) {
      left: 30px;
    }
  }
`;

const EventCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 25px;
  background: #ffffff;
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(75, 46, 131, 0.15);
  border: 1px solid rgba(75, 46, 131, 0.2);
  padding: 28px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
  transform: translateX(-30px);
  animation: eventEntrance 0.8s ease-out forwards;
  color: #000000;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    padding: 25px;
    border-radius: 14px;
  }
  
  @media (max-width: 480px) {
    gap: 18px;
    padding: 22px 20px;
    border-radius: 12px;
  }
  
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.3s; }
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12);
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    padding: 20px;
  }
  
  @keyframes eventEntrance {
    0% {
      opacity: 0;
      transform: translateX(-30px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

const EventDate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 80px;
  position: relative;
  z-index: 2;
  
  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    width: 12px;
    height: 12px;
    background: #4b2e83;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    box-shadow: 0 0 0 4px #ffffff;
  }
`;

const Day = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.2rem;
  background: #4b2e83;
  color: #ffffff;
  box-shadow: 0 8px 25px rgba(75, 46, 131, 0.15);
  transition: all 0.3s ease;
  position: relative;
  z-index: 3;
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 12px 35px rgba(75, 46, 131, 0.25);
  }
`;

const Month = styled.div`
  padding: 6px 12px;
  border-radius: 15px;
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #4b2e83;
  color: #ffffff;
`;

const EventImage = styled.div`
  width: 250px;
  min-width: 250px;
  height: 180px;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  border: 2px solid rgba(75, 46, 131, 0.1);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    display: block;
  }
  
  ${EventCard}:hover & {
    box-shadow: 0 8px 25px rgba(75, 46, 131, 0.2);
    border-color: rgba(75, 46, 131, 0.2);
    
    img {
      transform: scale(1.08);
    }
  }
  
  @media (max-width: 768px) {
    width: 100%;
    min-width: 100%;
    height: 220px;
    border-radius: 12px;
  }
  
  @media (max-width: 480px) {
    height: 200px;
    border-radius: 10px;
  }
`;

const EventContent = styled.div`
  flex: 1;
  
  h4 {
    margin-bottom: 10px;
    color: #4b2e83;
  }
`;

const EventTitle = styled.h4`
  margin-bottom: 10px;
  color: #4b2e83;
`;

const EventTime = styled.div`
  color: #000000;
  margin-bottom: 15px;
  padding: 6px 12px;
  background: rgba(75, 46, 131, 0.1);
  border-radius: 8px;
  display: inline-block;
`;

const EventLocations = styled.div`
  margin-bottom: 15px;
`;

const LocationItem = styled.div`
  color: #000000;
  font-size: 0.9rem;
  margin-bottom: 4px;
  padding-left: 15px;
  position: relative;
  
  &::before {
    content: '📍';
    position: absolute;
    left: 0;
    top: 0;
  }
`;

const EventDescription = styled.p`
  color: #000000;
  line-height: 1.6;
  margin-bottom: 15px;
`;

const EventTag = styled.span`
  display: inline-block;
  padding: 8px 16px;
  border-radius: 15px;
  font-weight: 700;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  cursor: pointer;
  
  /* Ensure text color is visible - will be overridden by className but provides fallback */
  color: #ffffff;
  
  &.whiteColor {
    color: #ffffff !important;
  }
  
  &.darkColor {
    color: #000000 !important;
    background-color: #dda61f !important;
  }
  
  /* Ensure background colors are applied */
  &.afriqBlueBg {
    background-color: #4b2e83 !important;
  }
  
  &.afriqRedBg {
    background-color: #4b2e83 !important;
  }
  
  &.afriqYellowBg {
    background-color: #dda61f !important;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }
`;
